import React from 'react';
import { ConsumptionGenerationChart } from './ConsumptionGenerationChart';

interface ConsumptionGenerationChartWrapperProps {
  startDate: string;
  endDate: string;
  isFullscreen?: boolean;
}

export function ConsumptionGenerationChartWrapper({ startDate, endDate, isFullscreen = false }: ConsumptionGenerationChartWrapperProps) {
  return (
    <div className={`text-left h-full w-full flex flex-col ${isFullscreen ? 'p-4' : ''}`}>
      <ConsumptionGenerationChart 
        startDate={startDate}
        endDate={endDate}
        isFullscreen={isFullscreen}
      />
    </div>
  );
}
